<header class="h-navbar bg-white border-b border-gray-200 flex items-center justify-between px-6 shrink-0">
  <div class="flex items-center gap-4">
    <button class="lg:hidden text-gray-600 hover:text-primary transition-colors">
      <lucide-icon name="Menu" [size]="24"></lucide-icon>
    </button>
    <app-breadcrumb></app-breadcrumb>
  </div>

  <div class="flex items-center justify-end gap-2 sm:gap-4">
    <button class="relative p-2 rounded-lg text-gray-500 hover:text-primary hover:bg-gray-100 transition-colors" title="Notifications">
      <lucide-icon name="Bell" [size]="20"></lucide-icon>
      <span class="absolute top-1 right-1 w-4 h-4 bg-rose-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">3</span>
    </button>

    <div class="flex items-center gap-3 pl-4 border-l border-gray-200">
      <div class="w-9 h-9 bg-primary rounded-full flex items-center justify-center text-white text-sm font-bold shrink-0">
        {{ initials }}
      </div>
      <div class="text-sm leading-tight hidden md:block" *ngIf="currentUser$ | async as user">
        <p class="font-medium text-gray-800">{{ user.name }}</p>
        <p class="text-gray-400 text-xs">{{ user.email }}</p>
      </div>
      <button (click)="logout()" class="p-2 rounded-lg text-gray-400 hover:text-rose-500 hover:bg-rose-50 transition-colors" title="Logout">
        <lucide-icon name="LogOut" [size]="18"></lucide-icon>
      </button>
    </div>
  </div>
</header>
<app-confirm-dialog
  [open]="showLogoutConfirm"
  title="Logout"
  message="Are you sure you want to log out?"
  confirmLabel="Logout"
  cancelLabel="Cancel"
  variant="danger"
  (confirm)="confirmLogout()"
  (cancel)="cancelLogout()">
</app-confirm-dialog>
